<template>
  <NuxtLayout name="base" :page="page">
    <LayoutContainer class="flex flex-col items-center">
      <DbcSvg name="dbc-oops" />
      <h1
        :class="{
          'dbc-text-color-primary': client !== 'cab' && client !== 'flinkster',
        }"
        class="mb-2xs text-center"
      >
        {{ $t('dbc-error-oops') }}
      </h1>
      <p class="mb-s">
        {{ $t('dbc-error-try-again-later') }}
      </p>
      <button
        :class="buttonSecondary"
        class="px-xs bg-transparent mb-s w-[293px]"
        @click="handleError"
      >
        {{ $t('dbc-btn-back-to-home') }}
      </button>
    </LayoutContainer>
  </NuxtLayout>
</template>

<script setup lang="ts">
provide('configuration', await useFetchConfiguration())
provide('apps', await useFetchApps())
provide('socialMedias', await useFetchSocialMedias())

const { setLocale } = useI18n()
const locale = useRoute().params.locale as string
setLocale(locale)

const client = useRuntimeConfig().public.client

const handleError = () => clearError({ redirect: getPagePath['home']![locale] })

const page: Page = {
  id: 0,
  title: '',
  path: '',
  description: '',
  content: [],
  locale: locale,
}
</script>
